/*
 * @Author: louis
 * @Date: 2021-07-19 10:25:41
 * @LastEditTime: 2021-07-28 16:58:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \nodeplsu\src\locales\zh-CN.js
 */
const zh_CN = {
  menu_home:'首页',
  menu_feature:"服务优势",
  menu_networks:"运行节点",
  menu_aboutUs:"关于我们",
  menu_faq:"常见问题",

  bannner_text:'区块链节点服务提供商',
  bannner_text2:'为机构投资者提供定制化的企业级Staking服务',
  banner_btn:"立即咨询",

  data_1:"管理资产",
  data_2:"累计创造价值",
  data_3:"累计安全运行",
  data_4:"共托管服务器",
  data_hours:"小时",

  feature_1:"定制化",
  feature_1_text:"使用定制化硬件钱包辅助工具，实现分钟级的开箱即用，提升业务效率",
  feature_1_text_2:" 提供定制化服务器和staking方案，量身打造专属节点，助力业务增长",

  feature_2:"可视化监控",
  feature_2_text:"打造实时高效的工具，随时随地监控节点运行状态",

  feature_3:"专业",
  feature_3_text:"专注staking领域超过4年，全球12+地区多数据中心分布式部署，保证节点低延时，高稳定，连续运行不宕机",


  feature_4:"收益最大化",
  feature_4_text:"在线率和出块数量居于行业前列，兼具针对性的调优策略，保证收益最大化",

  feature_5:"安全",
  feature_5_text:"零信任基础的专业技术方案保证私钥的绝对安全，封锁所有潜在财产损失风险",
  feature_5_text2:"7X24小时对区块链监控并自动预警，主动提前发现问题并处理，保障收益稳定",

  faq_q1: "NodePlus是什么?",
  faq_a1:["Nodeplus是一个BAAS（Blockchain as a service）区块链Staking云服务平台，提供一站式定制化服务。","使用Nodeplus服务，您不再需要招募自己的技术团队，就可以在全球多个机房部署区块链节点，由Nodeplus的区块链技术专家为您构建安全稳定的节点环境 ，这可以减少您的团队运营成本。"],
  faq_q2: "为什么要使用Nodeplus?",
  faq_a2: ["基于Nodeplus，您可以定制节点收益分配比例，节点名，以及其他相关信息。Nodeplus定期为您提供财务统计信息，历史收入情况一目了然。您只需要把精力集中在社区建设和Dapp研发上，繁琐的节点维护工作交给Nodeplus。"],
  faq_q3: "为什么Nodeplus比AWS/Google Could更适合您？",
  faq_a3:["不同的区块链网络，运行的客户端软件都完全不同，而目前存在POS区块链网络，就是百余种。而AWS和Google Cloud仅提供最基础的软件运行环境，无法预装、配置、维护不同的区块链网络客户端软件。 Nodeplus在Linux操作系统的基础上，再次封装区块链网络专属的操作系统，定制对应的系统给不同的区块链网络，预装了不同网络的客户端软件，以及相关的依赖软件。"],
  faq_q4: "怎样通过Nodeplus快速部署节点？",
  faq_a4:["请联系我们的商务，我们将以最短的时间为您部署相关的节点。"],


  ContactUs:'联系我们',
  YourName:'您的称呼',
  Email:'邮箱',
  Phone:"您的电话",
  message:'留言',
  aboutUs_info:"Nodeplus 是POS区块链（Proof os Staking）节点服务提供商，为企业客户提供定制化的Staking节点服务。我们的解决方案突出了保护资产安全, 投资回报最大化和定制化服务的特点。",
  aboutUs_info2:"团队在Staking行业深耕4年，积累了丰富的经验。Nodeplus是您在Staking领域的最佳合作伙伴。",
  send_btn:"发送",
  learn_more:"Stake Now",

  name_tip:"请输入您的称呼",
  email_tip:"请输入您的邮箱",
  email_correct:"请输入正确的邮箱",
  phone_tip:"请输入您的电话",
  leavel_message:"请输入您的留言",
  send_success:"提交成功",
  send_success_info:"我们将尽快与你联系！请您耐心等待！",
  network_error:"网络走丢啦，请刷新重试～",
  ok:"好的",
  
  footer_navigation:"导航",
  footer_address:"地址",
  footer_explain:"法律",
  footer_privacy:"隐私政策",
  footer_termsOfUse:"使用条款",




}
export default zh_CN; 